import React from 'react';
import { Search } from 'lucide-react';
import ModulePage from './ModulePage';

const scanChecks = (w) => [
  { label: 'Meta description', passed: !!w.has_meta_desc, detail: w.has_meta_desc ? 'Aanwezig' : 'Ontbreekt — Google toont zelf een beschrijving' },
  { label: 'H1 heading', passed: !!w.has_h1, detail: w.has_h1 ? 'Aanwezig' : 'Ontbreekt — belangrijk SEO signaal' },
  { label: 'Paginatitel', passed: !!w.title, detail: w.title ? `"${w.title}"` : 'Geen titel gevonden' },
  { label: 'Canonical tag', passed: !!w.has_canonical, detail: w.has_canonical ? 'Correct ingesteld' : 'Ontbreekt — risico op duplicate content' },
  { label: 'Schema markup', passed: !!w.has_schema, detail: w.has_schema ? 'Aanwezig' : 'Ontbreekt — geen rijke zoekresultaten' },
  { label: 'XML Sitemap', passed: !!w.has_sitemap, detail: w.has_sitemap ? 'Gevonden' : 'Niet gevonden — Google mist mogelijk pagina\'s' },
  { label: 'Open Graph tags', passed: !!w.has_og, detail: w.has_og ? 'Social previews correct' : 'Ontbreekt — slechte social media previews' },
];

export default function SEOPage() {
  return (
    <ModulePage
      category="seo"
      title="SEO"
      subtitle="Zoekmachineoptimalisatie — word beter gevonden in Google"
      icon={Search}
      color="#059669"
      scanChecks={scanChecks}
    />
  );
}
